import styled from 'styled-components';

export const Root = styled.div`
    display:flex;
    gap:7px;
`;

export const Line = styled.div`
    border-left: 1px solid rgba(204, 204, 204, 0.3);;
    height: 21px;
    margin-top: 12px;
`;